module.exports = __webpack_public_path__ + "assets/media/newaccount.3ae6bb45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/newaccount.svg
// module id = 3188
// module chunks = 0